module.exports = __webpack_public_path__ + "04e1c27bd04805ec36d9b0218f1877ac.svg";